import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

export const ProjectCard = ({ project, index = 0, tall = false }) => (
  <Reveal delay={index * 0.08} className="h-full">
    <Link
      to={`/projects/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className="group flex flex-col h-full bg-white border border-gray-200 transition-[box-shadow,transform] duration-500 hover:-translate-y-1 hover:shadow-lift"
    >
      <div className={`relative overflow-hidden ${tall ? "aspect-[4/5]" : "aspect-[4/3]"}`}>
        <img
          src={project.hero}
          alt={project.name}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <span className="absolute top-4 left-4 text-[10px] font-semibold uppercase tracking-[0.2em] bg-white/90 backdrop-blur px-3 py-1.5 text-navy">
          {project.status}
        </span>
      </div>
      <div className="flex flex-col gap-2 p-6 sm:p-8 grow">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-serif text-2xl text-ink tracking-tight">{project.name}</h3>
          <ArrowUpRight size={20} className="shrink-0 text-gray-300 transition-[color,transform] duration-300 group-hover:text-brand group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </div>
        <p className="flex items-center gap-1.5 text-sm text-gray-500">
          <MapPin size={14} className="text-brand" /> {project.location}
        </p>
        <p className="text-sm text-gray-600">{project.config}</p>
        <p className="mt-auto pt-4 text-[11px] uppercase tracking-[0.15em] text-gray-400">
          MahaRERA: {project.rera}
        </p>
      </div>
    </Link>
  </Reveal>
);
